module.exports = __webpack_public_path__ + "static/img/downIcon.0d4aab33.svg";